export default "__VITE_ASSET__CioOx_sR__"